// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"iy-z","hovered":"jy-z","hoverImage":"ky-z","mainImage":"ly-z","imageNoBackground":"my-z","fullSizeImage":"ny-z"};